import { render, staticRenderFns } from "./GrowthFileInformationComponent.vue?vue&type=template&id=2c09db4b&"
import script from "./GrowthFileInformationComponent.vue?vue&type=script&lang=js&"
export * from "./GrowthFileInformationComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports